import { render } from "./TutorialView.vue?vue&type=template&id=bf573612&scoped=true"
import script from "./TutorialView.vue?vue&type=script&lang=js"
export * from "./TutorialView.vue?vue&type=script&lang=js"

import "./TutorialView.vue?vue&type=style&index=0&id=bf573612&scoped=true&lang=css"

import exportComponent from "/home/lyramdc/Projects/face/ACE-face-name-test/v-face-memory/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf573612"]])

export default __exports__